import { api } from 'app/api';
import { selectSelectedEnvId } from 'app/containers/HiikoEnv/slice/selectors';
import { selectSelectedSeasonId } from 'app/containers/Season/slice/selectors';
import { useCreateOrUpdateTaskRoutes } from 'app/containers/Task/pages/CreateOrUpdateTask/hooks/useCreateOrUpdateTaskRoutes';
import { useSelector } from 'react-redux';
import { RoutesWithField } from '../../../../containers/Task/slice/types';
import { useRouteCheck } from '../../RoutesWithoutTaskListCard/hooks/useRouteCheck';
import moment from 'moment';

export const useTaskRoutesListCard = ({ taskId }: { taskId: number }) => {
  const envId = useSelector(selectSelectedEnvId) as number;
  const seasonId = useSelector(selectSelectedSeasonId) as number;

  const { taskRoutes, isFetching } = useCreateOrUpdateTaskRoutes({ taskId });

  const {
    data: fieldsResponse,
  } = api.endpoints.getFieldsGeometry.useQueryState({
    envId,
    seasonId,
    companyId: null,
    companyGroupId: null,
  });

  const groupedRoutes: RoutesWithField[] = taskRoutes.reduce(
    (accumulator: RoutesWithField[], route) => {
      const similiarRouteInAccumutalorIndex = accumulator.findIndex(
        routesGroup =>
          routesGroup.routes.find(
            groupRoute =>
              groupRoute.gpsVehicle.id === route.gpsVehicle.id &&
              groupRoute.fieldSeasonId === route.fieldSeasonId &&
              groupRoute.beaconId === route.beaconId &&
              moment(groupRoute.from).isSame(moment(route.from), 'day'),
          ),
      );

      if (similiarRouteInAccumutalorIndex === -1) {
        accumulator.push({
          routes: [route],
          field: fieldsResponse?.features.find(
            fieldFeature =>
              fieldFeature.properties.id ===
              (route.fieldSeasonId || route.nextFieldSeasonId),
          ),
        });
      } else {
        accumulator[similiarRouteInAccumutalorIndex].routes.push(route);
      }

      return accumulator;
    },
    [],
  );

  const {
    isAllRoutesChecked,
    checkedRouteIds,
    onRoutesCheck,
    onToggleAllRoutes,
  } = useRouteCheck({ routes: taskRoutes });

  return {
    groupedRoutes,
    isFetching,
    isAllRoutesChecked,
    checkedRouteIds,
    onRoutesCheck,
    onToggleAllRoutes,
  };
};
